// Minnesotaänger Mini App — minimal dialog (v1 rewrite).
// New code (not from telegram-tt). One-purpose overlay for contract-level
// errors (§3.4 failure dialogs): a dimmed backdrop, a centered card with an
// optional title and the message, and a single 关闭 button. Esc and backdrop
// click both close it. The content lives in shared state (global.miniapp.dialog,
// set by showDialog / cleared by closeDialog) — this component only renders it.
//
// Telegram-tt's Modal does far more (portals, transitions, focus traps,
// confirm/action variants); v1 deliberately renders a plain, animate-free
// card so SwiftUI's alert can map one-to-one onto the same state semantics.

import { memo, useEffect } from '../../lib/teact/teact';

import { getActions } from '../../global';

import Button from './Button';

import './Dialog.scss';

type OwnProps = {
  title?: string;
  message: string;
};

function Dialog({ title, message }: OwnProps) {
  const { closeDialog } = getActions();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeDialog();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [closeDialog]);

  return (
    <div className="Dialog-backdrop" onClick={() => closeDialog()}>
      <div className="Dialog" onClick={(e) => e.stopPropagation()} dir="auto">
        {title && <div className="Dialog-title">{title}</div>}
        <div className="Dialog-message">{message}</div>
        <div className="Dialog-actions">
          <Button size="tiny" onClick={() => closeDialog()}>关闭</Button>
        </div>
      </div>
    </div>
  );
}

export default memo(Dialog);
